/* Atribución de campaña (Mau, 2026-08-17).

   Captura `?ref=<slug>` en CUALQUIER página de la tienda y la recuerda,
   para dos cosas distintas con ventanas distintas:

   1. TAG DE LA ORDEN — la marca se escribe como atributo del carrito
      (`ref`), que viaja al pedido y lo lee un Shopify Flow para taguearlo
      ("venta protocolofacial"). Dura 14 DÍAS: alguien que vio el
      advertorial y compra al día 10 sigue contando como venta suya.
      Este patrón ya está probado en esta tienda: Social Snowball guarda
      su `__snowball` y Rebuy su `_source` en atributos del carrito.

   2. URGENCIA VISIBLE — la sección de escasez solo se enseña durante las
      primeras 24 H desde la PRIMERA visita atribuida. Por eso se guarda
      también ese instante, y NO se reinicia aunque la persona vuelva a
      entrar por el anuncio: si no compró en su ventana, se acabó.

   Cookie `skd_ref` = "<slug>|<timestamp ms de la primera visita>".
   Sin cookies escribibles, la atribución vive solo en esa carga: se
   degrada, no se rompe. */
(function () {
  'use strict';

  var COOKIE = 'skd_ref';
  var DIAS = 14;
  /* Solo estas campañas se aceptan: el valor acaba en un atributo de la
     orden, así que no se copia lo que venga en la URL a ciegas. */
  var PERMITIDOS = ['protocolofacial'];

  function leer() {
    var partes = ('; ' + document.cookie).split('; ' + COOKIE + '=');
    if (partes.length !== 2) return null;
    var crudo = decodeURIComponent(partes.pop().split(';').shift() || '');
    var trozos = crudo.split('|');
    if (!trozos[0]) return null;
    return { ref: trozos[0], desde: parseInt(trozos[1], 10) || Date.now() };
  }

  function escribir(ref, desde) {
    try {
      var caduca = new Date(Date.now() + DIAS * 86400000).toUTCString();
      document.cookie =
        COOKIE + '=' + encodeURIComponent(ref + '|' + desde) +
        '; expires=' + caduca + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  /* El atributo del carrito se repone una vez por sesión: si la clienta
     vació la cesta, el atributo se había ido con ella. */
  function marcarCarrito(ref) {
    try {
      if (sessionStorage.getItem('skd_ref_carrito') === ref) return;
    } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ref: ref } })
    }).then(function () {
      try { sessionStorage.setItem('skd_ref_carrito', ref); } catch (e) {}
    }).catch(function () {});
  }

  var entrante = null;
  try {
    var v = new URLSearchParams(window.location.search).get('ref');
    if (v && PERMITIDOS.indexOf(v.toLowerCase().trim()) !== -1) entrante = v.toLowerCase().trim();
  } catch (e) {}

  var guardado = leer();

  /* La ventana arranca en la PRIMERA visita atribuida y se conserva:
     volver a pinchar el anuncio no regala 24 h nuevas. */
  if (entrante) {
    var desde = guardado && guardado.ref === entrante ? guardado.desde : Date.now();
    escribir(entrante, desde);
    guardado = { ref: entrante, desde: desde };
  }

  if (guardado) marcarCarrito(guardado.ref);

  /* Lo dejamos publicado para que la sección de urgencia decida. */
  window.skindionAtribucion = guardado;
})();
